import React from 'react';

const Step1 = ({ formData, updateFormData }) => {
  const handleChange = (e) => {
    console.log('🔄 Step1 handleChange:', e.target.name, e.target.value);
    updateFormData({ [e.target.name]: e.target.value });
  };

  return (
    <div>
      <h3>Βήμα 1: Στοιχεία Αιτούντος</h3>
      
      <div className="alert alert-info" style={{ marginBottom: '30px' }}>
        <h4 style={{ marginTop: 0 }}>Καλωσορίσατε στον οδηγό αιτημάτων πολιτών</h4>
        <ul style={{ margin: '10px 0 0 20px', padding: 0 }}>
          <li>Παρακαλούμε ακολουθήστε τις οδηγίες βήμα προς βήμα</li>
          <li>Συμπληρώστε με ακρίβεια τα στοιχεία σας και επισυνάψτε τα απαιτούμενα δικαιολογητικά</li>
          <li>Η επεξεργασία και η αποστολή των αιτηθέντων εγγράφων θα πραγματοποιηθεί με ηλεκτρονικό τρόπο</li>
        </ul>
      </div>

      <div className="form-group">
        <label>
          Ο/Η αιτών/ούσα είναι: <span className="required">*</span>
        </label>
        <div className="radio-container" style={{ marginTop: '10px' }}>
          <label className="radio-option" style={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            marginBottom: '4px',
            padding: '10px 0 10px 0',
            border: `2px solid ${formData.requesterType === 'patient' ? '#3498db' : '#e0e0e0'}`,
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            maxWidth: '600px',
          }}>
            <input
              type="radio"
              name="requesterType"
              value="patient"
              checked={formData.requesterType === 'patient'}
              onChange={handleChange}
              style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px'}}
            />
            <div>
              <strong>Ο/Η ίδιος/α ο/η ασθενής</strong>
              <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                (Θα χρειαστείτε Υπεύθυνη Δήλωση)
              </div>
            </div>
          </label>
          
          <label className="radio-option" style={{ 
            display: 'flex',
            alignItems: 'flex-start',
            padding: '10px 0 10px 0',
            border: `2px solid ${formData.requesterType === 'representative' ? '#3498db' : '#e0e0e0'}`,
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            maxWidth: '600px',
          }}>
            <input
              type="radio"
              name="requesterType"
              value="representative"
              checked={formData.requesterType === 'representative'}
              onChange={handleChange}
              style={{ marginRight: '8px', marginTop: '3px', maxWidth: '30px',}}
            />
            <div>
              <strong>Ο/Η πληρεξούσιος/εξουσιοδοτημένος εκπρόσωπος του/της</strong>
              <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                (Θα χρειαστείτε Εξουσιοδότηση)
              </div>
            </div>
          </label>
        </div>
      </div>

      {formData.requesterType === 'representative' && (
        <div className="alert alert-info">
          <strong>⚠️ Σημείωση:</strong> Ως εκπρόσωπος ασθενούς, θα χρειαστείτε να παράσχετε εξουσιοδότηση 
          σύμφωνα με την ισχύουσα νομοθεσία (ΚΙΔ) για πρόσβαση στα ιατρικά δεδομένα του ασθενούς.
        </div>
      )}

      {formData.requesterType === 'patient' && (
        <div className="alert alert-info">
          <strong>✓ Επιλογή:</strong> Θα προχωρήσετε ως ασθενής. Στο επόμενο βήμα θα σας ζητηθεί να επιβεβαιώσετε 
          την ταυτότητά σας μέσω Υπεύθυνης Δήλωσης.
        </div>
      )}
    </div>
  );
};

export default Step1;
